<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a></a></li>
    <li class="active"><a>Device</a></li>
    <li class="active"><a>All Inventories</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="Inventory_outer">
          <div class="filter_div">
            <div class="left"></div>
            <div class="right">
              <button mat-stroked-button color="warn" (click)="deleteFWVersion()">
                <mat-icon style="color: red !important;" aria-hidden="false" aria-label="">delete</mat-icon>
                <span>Delete FW Version</span>
              </button>
              <button mat-raised-button color="primary" (click)="addNewInvenDevice(deviceTypeID)">
                <span class="sprite_icon plus_white"></span>
                <span>Add Device Version</span>
              </button>
            </div>
          </div>
          <div class="filter_div" *ngIf="tabFwSelected">
            <div class="right">
              <div class="custom_search_with_btn width_200">
                <input type="text" class="form-control" placeholder="Search By: mac address"
                  (input)="searchData($event.target.value)">
              </div>
              <button mat-raised-button color="primary"(click)="searchExecuteBtn()">
             <mat-icon>search</mat-icon>

              </button>
              <span class="custom_select_outer width_150">
                <select class="custom_select form-control" #fclient (change)="getAllInventory(1,fclient.value,'')">
                  <option value="null">Select Client</option>
                  <option *ngFor="let clients of allClients;" [value]="clients.id">{{clients.company_name}}</option>
                </select>
              </span>

              <span class="custom_select_outer width_170" >
                <label for="" style="display: inline-block; margin-top: 20px; margin-bottom: -10px;">Local Server:</label>
                <mat-radio-group aria-label="select an  option" [disabled]="fclient.value =='null'">
                  <mat-radio-group [(ngModel)]="selectedValue" (ngModelChange)="IPAddressFun()">
                    <mat-radio-button [value]="'on'">
                      <span class="vRadio" style="margin-left: 2px;">On</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="'off'">
                      <span class="vRadio" style="margin-left: 2px; margin-right:2px;">Off</span>
                    </mat-radio-button>
                  </mat-radio-group>
                </mat-radio-group>
              </span>
              <span class="custom_select_outer width_150">
                <select class="custom_select form-control" #f (change)="filterMethodSecond(f.value)">
                  <option>Select Version</option>
                  <option *ngFor="let versions of versionsList" [value]="versions.fw_version">
                    {{versions.fw_version}}</option>
                </select>
              </span>
              <button mat-raised-button color="primary" (click)="applyVersion()" [disabled]="applyBtn">
                <span>Apply</span>
              </button>
            </div>
          </div>



          <div class="filter_div" *ngIf="tabWifiSelected">
            <div class="left"></div>
            <div class="right">
              <div class="custom_search_with_btn width_200">
                <input type="text" class="form-control" placeholder="Search By: mac address"
                  (input)="searchData($event.target.value)">
              </div>
              <button mat-raised-button color="primary" (click)="searchExecuteBtn()">
                <mat-icon>search</mat-icon>
              </button>
              <span class="custom_select_outer width_150">
                <select class="custom_select form-control" #fclient (change)="getAllInventory(1,fclient.value,'')">
                  <option value="null">Select Client</option>
                  <option *ngFor="let clients of allClients;" [value]="clients.id">{{clients.company_name}}</option>
                </select>
              </span>
              <span class="custom_select_outer width_150">
                <select class="custom_select form-control" #f (change)="filterMethodSecond(f.value)">
                  <option>Select Version</option>
                  <option *ngFor="let versions of versionsList" [value]="versions.wifi_version">
                    {{versions.wifi_version}}</option>
                </select>
              </span>
              <button class="primary_btn" mat-raised-button (click)="applyVersion()" [disabled]="applyBtn">
                <span>Apply</span>
              </button>
            </div>
          </div>

          <ul ngbNav #ctdTabset="ngbNav" class="nav nav-tabs custom_tab"  class="custom_tab" (navChange)="beforeChange($event)">
            <li ngbNavItem="tab-1">
              <a ngbNavLink>Fw Versioning</a>
              <ng-template ngbNavContent>
                <div class="table-responsive2">
                  <table class="table table-hover unbordered_tb">
                    <thead>
                      <tr>
                        <th>Device Serial</th>
                        <th>Mac Address</th>
                        <th>Registration Status</th>
                        <th>Fw Current Version</th>
                        <th>Device Status</th>
                        <th>
                          <input type="checkbox" [(ngModel)]="isAllSelected" name="list_name" value="m1"
                            (change)="checkUncheckAll($event)" /> <strong style="margin-left: 5px;">Select/ Unselect
                            All</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="padding: 10px; font-size: 20px !important;" *ngFor="let listItem of deviceInventoryList | paginate : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: count
                            };
                            let idx = index" [class.active]="idx == currentIndex">
                        <td>{{listItem.name}}</td>
                        <td>{{listItem.mac_address}}</td>
                        <td>{{listItem.status}}</td>
                        <td>
                          {{listItem?.installed_firmware_version || 'Not mentioned'}}
                        </td>
                        <td>
                          <mat-icon *ngIf="listItem.asset_status !== 2" style="color: green;">wifi</mat-icon>
                          <mat-icon *ngIf="listItem.asset_status === 2" style="color: red;">wifi_off</mat-icon>
                        </td>
                        <td class="text-center">
                          <label>
                            <input type="checkbox" [(ngModel)]="listItem.isSelected" name="list_name"
                              value="{{listItem.id}}" (change)="onCheckboxChange($event)" />
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div *ngIf="emptyMsg !== false" class="no_result">
                  <p>No results</p>
                </div>
                <div *ngIf="emptyMsg == false" class="d-flex justify-content-center">
                  <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                    (pageChange)="onTableDataChange($event)">
                  </pagination-controls>
                </div>
              </ng-template>
            </li>


            <li ngbNavItem="tab-2">
              <a ngbNavLink>Wifi Versioning</a>
              <ng-template ngbNavContent>

                <div class="table-responsive2">
                  <table class="table table-hover unbordered_tb">
                    <thead>
                      <tr>
                        <th>Device Serial</th>
                        <th>Mac Address</th>
                        <th>Registration Status</th>
                        <th>Wifi Current Version</th>
                        <th>
                          <input type="checkbox" [(ngModel)]="isAllSelected" name="list_name" value="m1"
                            (change)="checkUncheckAll($event)" /> <strong style="margin-left: 5px;">Select/ Unselect
                            All</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let listItem of deviceInventoryList | paginate : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: count
                            };
                            let idx = index" [class.active]="idx == currentIndex">
                        <td>{{listItem.name}}</td>
                        <td>{{listItem.mac_address}}</td>
                        <td>{{listItem.status}}</td>
                        <td>
                          {{listItem?.wifi_installed_version || 'Not mentioned'}}
                        </td>
                        <td class="text-center">
                          <label *ngIf="listItem.wifi_installed_version === '' || listItem.wifi_installed_version === 'undefined' || listItem.wifi_installed_version === null;else nextOne">
                            <input type="checkbox" [disabled]="true" name="list_name" />
                          </label>
                          <ng-template #nextOne>
                            <label >
                              <input type="checkbox" [(ngModel)]="listItem.isSelected" name="list_name"
                                value="{{listItem.id}}" (change)="onCheckboxChange($event)" />
                            </label>
                          </ng-template>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div *ngIf="emptyMsg !== false" class="no_result">
                  <p>No results</p>
                </div>
                <div *ngIf="emptyMsg == false" class="d-flex justify-content-center">
                  <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                    (pageChange)="onTableDataChange($event)">
                  </pagination-controls>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="ctdTabset"></div>




        </div>
      </div>
    </div>
  </div>
</div>
